
import { Button } from "@/components/ui/button";

interface AuthFormActionsProps {
  isLoading: boolean;
  isSignUp: boolean;
  error: string | null;
  onForgotPassword: () => void;
  onToggleFormType: () => void;
}

export const AuthFormActions = ({
  isLoading,
  isSignUp,
  error,
  onForgotPassword,
  onToggleFormType,
}: AuthFormActionsProps) => {
  return (
    <div className="mt-6 space-y-4">
      {error && (
        <div className="text-red-500 text-sm text-center">{error}</div>
      )}

      <div className="text-xs text-gray-400 text-center mb-4">
        This site is protected by reCAPTCHA and the Google{' '}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">
          Privacy Policy
        </a>{' '}
        and{' '}
        <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">
          Terms of Service
        </a>{' '}
        apply.
      </div>

      <Button
        type="submit"
        className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium py-3 transition-all duration-200 shadow-lg hover:shadow-blue-500/25"
        disabled={isLoading}
      >
        {isLoading ? (
          <div className="flex items-center justify-center gap-2">
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Loading...
          </div>
        ) : (
          <span className="flex items-center justify-center gap-2">
            {isSignUp ? "Create Account" : "Sign In"}
            {!isLoading && <span>→</span>}
          </span>
        )}
      </Button>

      {!isSignUp && (
        <div className="text-center">
          <Button
            type="button"
            variant="link"
            className="text-blue-400 hover:text-blue-300 text-sm"
            onClick={onForgotPassword}
          >
            Forgot password?
          </Button>
        </div>
      )}

      <div className="pt-4 border-t border-gray-600/50">
        <div className="text-center">
          <p className="text-sm text-gray-400 mb-3">
            {isSignUp ? "Already have an account?" : "Don't have an account?"}
          </p>
          <Button
            type="button"
            variant="outline"
            className="bg-gradient-to-r from-blue-600/10 to-purple-600/10 border-blue-500/50 text-blue-400 hover:bg-gradient-to-r hover:from-blue-600/20 hover:to-purple-600/20 hover:border-blue-400 hover:text-blue-300 transition-all duration-200 px-8 py-2 font-medium"
            onClick={onToggleFormType}
          >
            {isSignUp ? "Sign In" : "Sign Up"}
            <span className="ml-2">→</span>
          </Button>
        </div>
      </div>
    </div>
  );
};
